<template>
  <button
    v-show="visible"
    type="button"
    class="back-to-top"
    aria-label="回到顶部"
    @click="scrollTop"
  >
    <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
      <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
    </svg>
  </button>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'

const visible = ref(false)

function onScroll() {
  visible.value = window.scrollY > 400
}

function scrollTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

onMounted(() => window.addEventListener('scroll', onScroll, { passive: true }))
onUnmounted(() => window.removeEventListener('scroll', onScroll))
</script>

<style scoped>
.back-to-top {
  position: fixed;
  right: 24px;
  bottom: 88px;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
  background: var(--gradient-brand);
  color: #fff;
  cursor: pointer;
  box-shadow: var(--shadow-brand);
  z-index: 280;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s var(--ease-smooth), box-shadow 0.3s;
}

.back-to-top:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 28px rgba(23, 107, 137, 0.35);
}
</style>
